import { safeLocalStorage } from "utils/safeStorage";

const TOKEN_KEY = "token";
export function getTokenSilently(): string | null {
  const itemStr = safeLocalStorage.getItem(TOKEN_KEY);

  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);

  if (Date.now() / 1000 > item.expiry) {
    safeLocalStorage.removeItem(TOKEN_KEY);
    return null;
  }
  return item.value;
}
